import { valOr } from '../SharedUtils'
import { Field } from './Field'
import * as ser from './SerUtil'

/*
Used to store an output value of a calculation, which
will be displayed in the UI. Meant to be like a fixed version
of 'Field'.

It should display the 'display' value/units of a field or result.
*/
export class OutputValue {
  static serInfo = {
    type: 'OutputValue',
  }

  constructor(name, valueStr, unitsStr, errorMsg, opts) {
    this.name = name
    this.valueStr = valueStr
    this.unitsStr = unitsStr
    this.errorMsg = errorMsg
    this.opts = valOr(opts, {});

    this.serFields = [
      ser.staticField('_type', 'OutputValue'),
      'name',
      'valueStr',
      'unitsStr',
      'errorMsg',
      'opts',
    ]
  }

  getValueStr() {
    return this.valueStr
  }

  getSpreadsheetValueStr() {
    let numValue = Number(this.valueStr.replace(/,/g, '')); // Remove commas for number conversion
    if (isNaN(numValue)) {
      return this.valueStr; // Return as string if not a number
    }
    return numValue; // Return as number if valid
  }

  getDisplayValueStr() {
    // We are already in display units
    return this.getValueStr();
  }

  getDisplayUnitsLabel() {
    return this.unitsStr
  }

  getErrorMsg() {
    return this.errorMsg
  }

  getPlainLabel() {
    if (this.opts.plainLabel) {
      return this.opts.plainLabel;
    }
    return this.name;
  }

  static createSimple(name, fieldType, value, otherOpts) {
    otherOpts = valOr(otherOpts, {});
    let outputField = Field.makeOutput(name, fieldType, value, {
      ...otherOpts,
      // We don't want to clamp the value, since it's already calculated
      clampValue: false,
    })
    return OutputValue.createFromField(outputField, otherOpts)
  }

  static createFromField(field, opts) {
    opts = valOr(opts, {});
    let name = valOr(opts.name, field.name);
    let inputType = field.getInputType();
    // NOTE - take the valueStr and unitsStr in display units.
    // OutputValue is meant for display only.
    let valueStr = field.getDisplayValueStr();
    let unitsStr = inputType == 'Number' ? field.getDisplayUnitsLabel() : null;
    let errorMsg = field.getErrorString()
    return new OutputValue(name, valueStr, unitsStr, errorMsg, opts)
  }
}
